import { Flex, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { ScreeningResultsOrStatus } from "../../types";
import { screeningStatusCellWrapper_Style } from "./styles_vanilla.css";

interface Props {
  hasIcon?: boolean;
  iconType?: IconType;
  color: Colors;
  text: string;
  type?: ScreeningResultsOrStatus;
}

export const ScreeningStatusCell = ({
  hasIcon = false,
  iconType,
  color,
  text,
  type,
}: Props) => {
  return (
    <Flex alignItems="center" gap={8} className={screeningStatusCellWrapper_Style}>
      {hasIcon && iconType && (
        <Icon
          data-testid={`${type}-icon`}
          data-cy={`${type}-icon`}
          type={iconType}
          color={color}
          variant="outline"
        ></Icon>
      )}
      <Text data-testid={`${type}`} data-cy={`${type}`} style={{ color: color }}>
        {text}
      </Text>
    </Flex>
  );
};
